import * as types from './types'

export const mutations = {
  [types.SET_CABINETS] (state, cabinets) {
		state.cabinets = [...cabinets]
	},
	[types.CREATE_CABINET] (state, { cabinet }) {
		state.cabinets.push(cabinet)
	},
	[types.EDIT_CABINET] (state, { cabinet }) {
        const {cabinets} = state
        state.cabinets.forEach((el, index) => {
            if (cabinet.id === el.id) {
                cabinets[index] = {...cabinet}
            }
        });
        state.cabinets = [...cabinets]
  },
  [types.SET_CLIENTS_BY_OFFICEID] (state, {officeId, clients}) {
		let officeIndex = state.cabinets.findIndex((office) => {
      return office.id === officeId
    })
    state.cabinets[officeIndex].clients = clients;
	},
  [types.SET_ADVISORS_BY_OFFICEID] (state, {officeId, advisors}) {
		let officeIndex = state.cabinets.findIndex((office) => {
      return office.id === officeId
    })
    state.cabinets[officeIndex].advisors = advisors;
	},
  [types.SET_ADMIN_BY_OFFICEID] (state, {officeId, admin}) {
		let officeIndex = state.cabinets.findIndex((office) => {
      return office.id === officeId
    })
    state.cabinets[officeIndex].admin = admin;
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Cabinets/mutations.js